import React, { useState } from "react";
import { Button, Paper, Table, TableContainer } from "@mui/material";
import {
  Navigation,
  PageHeader,
  ClientTableBody,
  Loader,
  ClientCreateModal,
  TableHeader,
} from "../components";
import { useGetClientListQuery } from "../store/services/client.api";
import { PAGINATION_LIMIT } from "../utils/consts";
import { createColumnData } from "../utils/stages";
import { useVerticalScroll } from "../hooks/useVerticalScroll";

import { COLORS } from "../styles/colors";

const columns = [
  createColumnData("Client", "name", "client.name", true),
  createColumnData("Stages Quantity", "stages", "client.stages_count", true),
];

const ClientList = () => {
  const paginationLimit = PAGINATION_LIMIT;

  const [openModal, setOpenModal] = useState(false);
  const [offset, setOffset] = useState(0);
  const [orderBy, setOrderBy] = useState("");

  const { data, isLoading, isFetching } = useGetClientListQuery({
    paginationLimit,
    offset,
    orderBy,
  });

  useVerticalScroll({
    containerId: "table",
    isFetching,
    isNextPage: data?.isNextPage,
    paginationLimit,
    onPaginate: (limit) => setOffset((prev) => prev + limit),
  });

  const handleSetRefresh = () => {
    setOffset(0);
    setOrderBy("");
  };

  const handleSetOrderBy = (value) => {
    setOffset(0);
    setOrderBy(value);
  };

  const tableWrapperStyle = {
    maxHeight: `calc(100vh - ${29 + 71}px)`,
    overflowX: "auto",
    border: `1px solid ${COLORS.utility.border}`,
    borderTop: 0,
    borderRadius: "0 0 7px 7px",
  };

  return (
    <Navigation>
      <ClientCreateModal
        isOpen={openModal}
        setIsOpen={setOpenModal}
        setRefresh={handleSetRefresh}
      />
      <PageHeader
        title={"Clients"}
        action={
          <Button onClick={() => setOpenModal(!openModal)} variant="contained">
            Add new client
          </Button>
        }
      />

      <TableContainer container={Paper}>
        <div style={tableWrapperStyle} id="table">
          <Table>
            <TableHeader
              columns={columns}
              orderBy={orderBy}
              setOrderBy={handleSetOrderBy}
              isHaveAction
            />
            <ClientTableBody rows={data?.rows} />
          </Table>
        </div>
      </TableContainer>

      <Loader isLoading={isLoading || isFetching} />
    </Navigation>
  );
};

export default ClientList;
